module.exports = __webpack_public_path__ + "static/media/up-arrow.dd886e3a.svg";